import { PERCHE_CARDS } from "@/lib/audience";
import { Reveal } from "@/components/motion";

export const PercheCards = () => (
  <section className="py-14 sm:py-28 border-t border-[#141414]" data-testid="perche-cards-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <Reveal>
        <p className="eyebrow mb-5">In pratica</p>
        <h2
          className="text-3xl sm:text-4xl font-bold text-white max-w-3xl leading-tight"
          style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.025em" }}
          data-testid="perche-cards-h2"
        >
          Cosa significa, <span className="text-[#FACC15]">in pratica</span>
        </h2>
      </Reveal>

      <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6">
        {PERCHE_CARDS.map((c, i) => (
          <Reveal key={c.n} delay={i * 0.1}>
            <div className="lift border border-[#1a1a1a] bg-[#0c0c0c] p-7 h-full" data-testid={`perche-card-${c.n}`}>
              <p className="text-[#FACC15] text-3xl font-bold mb-5" style={{ fontFamily: "'Outfit', sans-serif" }}>
                {c.n}
              </p>
              <h3 className="text-white text-xl font-semibold mb-3" style={{ fontFamily: "'Outfit', sans-serif" }}>
                {c.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">{c.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default PercheCards;
